export default "__VITE_ASSET__fa947689__"